export enum ProductType {
  ALevel = `A-Level`,
  Choice = `Choice`,
  EnglishLanguage = `English Language`,
}
